/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Scope_InvalidInputs */

const vi_api_keys_scope_invalid = /** @type {(inputs: Api_Keys_Scope_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại khóa không hợp lệ. Chọn lại loại khóa trong danh sách.`)
};

/**

* @param {Api_Keys_Scope_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_scope_invalid = /** @type {((inputs?: Api_Keys_Scope_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Scope_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_scope_invalid(inputs)
});